/**
 * Maps Auth0 callback / access_denied outcomes to Portal login UI copy.
 * Salesforce approval denial is the default; email verification and MFA need distinct guidance.
 */

export const LOGIN_ACCESS_DENIED_REASONS = {
	WAITING_APPROVAL: 'WAITING_APPROVAL',
	EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
	MFA_REQUIRED: 'MFA_REQUIRED',
};

export const LOGIN_ACCESS_DENIED_MESSAGES = {
	[LOGIN_ACCESS_DENIED_REASONS.WAITING_APPROVAL]:
		"Almost there, your account is being verified. You'll be notified within 1 business day.",
	[LOGIN_ACCESS_DENIED_REASONS.EMAIL_NOT_VERIFIED]:
		'Please check your email and click the verification link we sent you. After verifying, wait for account approval before signing in again.',
	[LOGIN_ACCESS_DENIED_REASONS.MFA_REQUIRED]:
		'Please scan the QR code with your authenticator app to finish setting up multi-factor authentication, then try signing in again.',
};

const EMAIL_HINTS = [
	'email we have sent you',
	'verify your email',
	'email_verified',
	'email not verified',
	'verification link',
	'confirm your email',
];

const MFA_HINTS = [
	'mfa',
	'multifactor',
	'multi-factor',
	'multi factor',
	'guardian',
	'authenticator',
	'qr code',
	'one-time password',
	'otp',
];

function includesAny(haystack, needles) {
	return needles.some((needle) => haystack.includes(needle));
}

/**
 * @param {string|null|undefined} errorDescription Auth0 error_description (decoded)
 * @param {string|null|undefined} reason Optional explicit reason query/param
 */
export function classifyLoginAccessDeniedReason(errorDescription, reason) {
	const normalizedReason = (reason || '').trim().toUpperCase();
	if (normalizedReason && LOGIN_ACCESS_DENIED_MESSAGES[normalizedReason]) {
		return normalizedReason;
	}

	const description = decodeURIComponent(errorDescription || '')
		.trim()
		.toLowerCase();

	if (includesAny(description, EMAIL_HINTS)) {
		return LOGIN_ACCESS_DENIED_REASONS.EMAIL_NOT_VERIFIED;
	}

	if (includesAny(description, MFA_HINTS)) {
		return LOGIN_ACCESS_DENIED_REASONS.MFA_REQUIRED;
	}

	return LOGIN_ACCESS_DENIED_REASONS.WAITING_APPROVAL;
}

export function getLoginAccessDeniedMessage(errorDescription, reason) {
	return LOGIN_ACCESS_DENIED_MESSAGES[
		classifyLoginAccessDeniedReason(errorDescription, reason)
	];
}

export const VERIFY_EMAIL_MESSAGE =
	LOGIN_ACCESS_DENIED_MESSAGES[LOGIN_ACCESS_DENIED_REASONS.EMAIL_NOT_VERIFIED];
